<template>

  <v-card elevation="0" class="annotation mb-4">
    <v-card-title class="text-subtitle-1 mb-2 pb-2" style="border-bottom: 1px solid #efefef">
      <div class="d-flex flex-column flex-md-row align-start align-md-center justify-space-between w-100">

        <div class="user-info d-flex flex-row align-center">
          <v-img max-width="80px" height="80px" class="rounded-circle mr-3" v-if="annotation.user_created.avatar"
          :src="`https://api.mylegis.com.br/assets/${annotation.user_created.avatar.id}`" />
        <v-img max-width="80px" height="80px" class="rounded-circle mr-3" v-if="!annotation.user_created.avatar" contain
          src="../assets/icon-person.svg" />
          <div class="user-name">
            <router-link style="font-weight: 600; text-decoration: none;" :to="`/painel/u/${slugName(annotation.user_created)}`" class="mr-2">
              {{
                annotation.user_created.first_name
              }}

              {{ annotation.user_created.last_name !== null ? annotation.user_created.last_name : "" }}
            </router-link>  
            <div v-if="annotation.id_lei"  class="law-reference">
            
            <span class="text-caption">em</span>
            <router-link class="ml-2 law-link"
              :to="'/painel/lei/' + annotation.id_lei.id_lei + '/' + sanitizeTitle(annotation.id_lei.numero_lei)">
              {{ annotation.id_lei.numero_lei }}
            </router-link>
          </div>
          </div>
        
        </div>
        <div  class="d-flex  flex-column align-start align-md-end justify-end mt-2 mt-md-0" >
          <div class="d-flex align-center mb-1 mb-md-0" v-if="annotation.status === `group`">
            <v-icon small class="mr-1" color="grey">mdi-earth</v-icon>
            <span class="text-caption grey--text">{{ annotation.id_grupo.nome_grupo }}</span>
          </div>

          <div class="d-flex align-center mb-1 mb-md-0" v-else>
            <v-icon small class="mr-1" color="grey">{{
              annotation.status === `private`
                ? `mdi-lock`
                : `mdi-earth`
            }}</v-icon>
            {{ annotation.status | filterStatus }}
          </div>

          <div class="d-flex align-center ml-md-3">
            <v-icon small class="mr-1" color="grey">mdi-clock-outline</v-icon>
            <span class="text-caption grey--text">
              Criado em {{ annotation.date_updated === null ? annotation.date_created : annotation.date_updated
                | brdatetime }}
            </span>
          </div>
        </div>
      </div>
    </v-card-title>

    <v-card-text class="annotationText pa-4">
      <div class="mb-3" v-if="annotation.id_reg">
        <strong>Parágrafo da lei:</strong>
        <div class="reg mx-0 mt-2" v-html="annotation.id_reg.conteudo"></div>
      </div>

      <div class="mb-3">
        <div class="mb-2" v-html="annotation.texto"></div>
      </div>
    </v-card-text>

    <v-card-actions class="d-flex flex-column align-end justify-end pa-3 pa-md-4" style="border-top: 1px solid #efefef">
      <div class="d-flex flex-column flex-md-row align-start align-md-center mb-3 w-100">
        <div class="d-flex flex-wrap mb-2 mb-md-0">
          <v-btn text class="mr-2 mr-md-4 mb-1 mb-md-0" small
            @click="annotation.likes.some(l => l.id === user.id) ? unlikeAnnotation() : likeAnnotation()">
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-thumb-up</v-icon>
            <span class="d-none d-sm-inline"> {{ annotation.likes.length }}
              {{annotation.likes.some(l => l.id === user.id) ? "Descurtir" : `Curtir`}}</span>
          </v-btn>
          <v-btn text class="mr-2 mr-md-4 mb-1 mb-md-0" small @click="showComments = !showComments">
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-comment</v-icon>
            <span class="d-none d-sm-inline">{{ annotation.comentarios ? annotation.comentarios.length : 0 }}
              Comentários</span>
          </v-btn>
          <!-- :disabled="user.plano === `plano-free` || user.plano == ``"  -->

          <v-btn 
            v-if="annotation.id_lei"
            text
            class="mr-2 mr-md-4 mb-1 mb-md-0" 
            @click="importPost = { ...annotation }; showNewAnnotation = true" 
            small>
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-share</v-icon>
            <span class="d-none d-sm-inline">Importar post</span>
          </v-btn>
          <v-btn 
            v-if="annotation.user_created && annotation.user_created.id === user.id"
            text
            class="mr-2 mr-md-4 mb-1 mb-md-0" 
            @click="confirmDelete = true" 
            small>
            <v-icon class="mr-1 mr-md-2" color="#F15A24" size="16">mdi-delete</v-icon>
            <span class="d-none d-sm-inline">Excluir</span>
          </v-btn>
        </div>
      </div>


      <div class="d-flex align-start w-100 mt-4">
        <!-- Avatar do usuário -->
        <div class="mr-2 flex-shrink-0">
          <v-img 
            max-width="32px" 
            height="32px" 
            class="rounded-circle"
            style="border: 1px solid rgba(0,0,0,0.1);"
            :src="user.avatar !== null ? `https://api.mylegis.com.br/assets/${user.avatar}` : require(`../assets/icon-person.svg`)" 
          />
        </div>

        <!-- Área de comentário estilo Facebook -->
        <div class="flex-grow-1 d-flex flex-column">
          <!-- Campo de texto com borda arredondada -->
          <div 
            class="comment-input-container"
          >
            <v-text-field 
              v-model="comment" 
              placeholder="Escreva um comentário..." 
              hide-details 
              color="#F15A24" 
              :disabled="loadingComment"
              flat
              dense
              solo
              class="comment-text-field"
              @keyup.enter="handleEnterKey"
            >
              <template v-slot:append-outer>
                <div class="d-flex align-center" style="gap: 4px;">
                  <v-btn
                    icon
                    x-small
                    text
                    @click="triggerFileInput"
                    :disabled="loadingComment"
                    class="attachment-btn"
                  >
                    <v-icon small color="grey darken-1">mdi-image-outline</v-icon>
                  </v-btn>
                  <v-btn
                    v-if="comment.trim() || commentFiles.length > 0"
                    icon
                    x-small
                    text
                    @click="postComment"
                    :loading="loadingComment"
                    :disabled="loadingComment"
                    class="send-btn"
                  >
                    <v-icon small color="#F15A24">mdi-send</v-icon>
                  </v-btn>
                </div>
              </template>
            </v-text-field>
            
            <!-- Input de arquivo oculto -->
            <v-file-input 
              ref="fileInput"
              v-model="file"
              @change="handleFileAdded(file)" 
              :disabled="loadingComment"
              style="display: none;"
              hide-input
            ></v-file-input>
            
            <!-- Preview dos anexos - usando v-chip como nos comentários, dentro do container -->
            <div v-if="commentFiles.length > 0" class="d-flex flex-wrap align-center px-2 pb-1 pt-1" style="gap: 8px;">
              <v-chip 
                v-for="(f, index) in commentFiles" 
                :key="f.id" 
                class="ma-0" 
                close
                @click:close="commentFiles.splice(index, 1)" 
                color="#F15A24" 
                text-color="white"
                small
                style="max-width: 100%;"
              >
                <v-icon left small>mdi-file</v-icon>
                <span style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">
                  {{ f && f.filename_download ? truncateFilename(f.filename_download) : (f && f.id ? truncateFilename(String(f.id)) : 'Anexo') }}
                </span>
              </v-chip>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de comentários - ocupando toda a largura -->
      <div class="mt-4 w-100">
        <v-divider class="mb-4"></v-divider>

        <!-- Mensagem quando não há comentários -->
        <div v-if="!annotation.comentarios || annotation.comentarios.length === 0" class="text-center pa-4">
          <v-icon color="grey" size="48" class="mb-2">mdi-comment-outline</v-icon>
          <p class="grey--text">
            Seja o primeiro a comentar neste post, digite sua mensagem no campo acima e pressione o botão!
          </p>
        </div>

        <!-- Lista de comentários -->
        <div v-else class="w-100">
          <v-list class="pa-0 w-100">
            <v-list-item v-for="(item, i) in annotation.comentarios" :key="i" class="px-0 mb-3 w-100"
              style="border: 1px solid #e0e0e0; border-radius: 8px; background-color: #fafafa;">
              <v-list-item-avatar class="mr-3">
                <v-avatar color="grey" size="40">
                  <v-img contain :src="item.user_created.avatar && item.user_created.avatar.id
                    ? `https://api.mylegis.com.br/assets/${item.user_created.avatar.id}`
                    : `https://api.mylegis.com.br/assets/${item.user_created.avatar}`" />
                </v-avatar>
              </v-list-item-avatar>

              <v-list-item-content class="py-2 flex-grow-1">
                <v-list-item-title class="font-weight-bold text-subtitle-2">
                  {{ item.user_created.first_name }}
                </v-list-item-title>
                <v-list-item-subtitle class="text-body-2 mt-1">
                  {{ item.message }}
                </v-list-item-subtitle>

                <!-- Anexos do comentário -->
                <div v-if="item.files && item.files.length > 0" class="mt-2 d-flex flex-wrap" style="gap: 8px;">
                  <v-chip 
                    v-for="(f, index) in item.files" 
                    :key="f.id" 
                    small 
                    class="ma-0" 
                    color="#F15A24" 
                    text-color="white"
                    style="cursor: pointer; max-width: 100%;"
                  >
                    <v-icon left small>mdi-file</v-icon>
                    <span style="max-width: 150px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block;">
                      {{ f && f.directus_files_id && f.directus_files_id.filename_download ? truncateFilename(f.directus_files_id.filename_download) : `Anexo${index > 0 ? ` ${index + 1}` : ''}` }}
                    </span>
                    <v-icon 
                      right 
                      small 
                      @click.stop="downloadFile(f.directus_files_id.id)"
                      style="cursor: pointer; margin-left: 4px;"
                    >
                      mdi-download
                    </v-icon>
                  </v-chip>
                </div>
              </v-list-item-content>

              <v-list-item-action v-if="item.user_created.id == user.id" class="ml-2">
                <v-btn color="grey" icon small @click="deleteComment(item.id)">
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </div>
      </div>
    </v-card-actions>

    <v-dialog width="25vw" v-model="confirmDelete">
      <v-card>
        <v-card-title>Remover Anotação</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <h2 style="gap: 1rem; color: #f15a24">
                <v-icon>mdi-account-trash</v-icon>Você tem certeza que deseja remover esta anotação?<br />
                <small class="black--text text-caption">Obs: Esta ação é irreversível.</small>
              </h2>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn text @click="confirmDelete = false">Cancelar</v-btn>
          <v-btn color="#F15A24" :loading="loadingDelete" @click="deleteAnnotation()" dark>Remover</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog width="85vw" v-model="showNewAnnotation">
      <v-card class="px-5">
        <v-card-title class="px-0">Importar Anotação <v-spacer />
          <v-btn @click="showNewAnnotation = false" text><v-icon large>mdi-close</v-icon></v-btn></v-card-title>
        <v-card-text>
          <h3></h3>
          <p v-if="importPost.id_lei" class="pa-2" style="border: 1px dashed #f15a24">{{ importPost.id_lei.numero_lei }}</p>
          <p v-if="importPost.id_reg" class=" mx-0 "> {{ importPost.id_reg.conteudo }} </p>
          <h3>Vade-mécum</h3>
          <v-select color="#F15A24" :items="vadeMecuns" v-model="importPost.id_vademecum" item-text="titulo"
            item-value="id">
            <!-- <template v-slot:prepend-item="[item]">
							{{ item.id }}
						</template> -->
          </v-select>
          <h3>Visibilidade</h3>
          <v-select color="#F15A24" :items="statusAnnotation" v-model="importPost.status"></v-select>
          <h3 v-if="importPost.status == `group`">Selecione o grupo</h3>
          <v-select v-if="importPost.status == `group`" item-text="grupos_id.nome_grupo" item-value="grupos_id.id"
            color="#F15A24" :items="groups" v-model="importPost.id_grupo"></v-select>
          <h3 class="d-flex">
            Conteúdo
          </h3>
          <VueEditor use-custom-image-handler @image-added="handleImageAdded" ref="editor" color="#F15A24"
            :editor-toolbar="customToolbar" v-model="importPost.texto" />
        </v-card-text>
        <v-card-actions class="justify-end px-0">
          <v-btn text @click="showNewAnnotation = false">Cancelar</v-btn>
          <v-btn :loading="loadingNewAnnotation" dark @click="saveNewAnnotation()" color="#F15A24">Salvar
            <v-icon class="ml-1" small>mdi-content-save</v-icon></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>


</template>

<style scoped>
h5 {
  color: #F15A24 !important;
}

.annotation {
  border: 1px solid rgb(200 200 200) !important;
  margin: 8px 0px;
  border-radius: 10px;
}

.annotationText div {
  width: 100%;
}

.secondRow h3 {
  margin: 30px 0px 0px 15px;
}

.annotation ::v-deep img,
.comentario ::v-deep img {
  max-width: 100% !important;
}

.reg {
  background-color: #efefef;
  border-radius: 10px;
  padding: 15px;
}

.annotation ::v-deep a {
  color: black !important;
  text-decoration: underline;
  padding: 0
}

a:hover,
.annotation ::v-deep a:hover {
  text-decoration: underline;
  color: #F15A24 !important;
}

/* Estilos para chips de anexos */
.annotation ::v-deep .v-chip--close .v-chip__close {
  opacity: 1 !important;
  color: white !important;
}

.annotation ::v-deep .v-chip--close .v-chip__close:hover {
  opacity: 0.8 !important;
  color: white !important;
}

.annotation ::v-deep .v-chip {
  cursor: pointer;
}

/* Garantir que o ícone de fechar seja branco mesmo quando o chip está laranja */
.annotation ::v-deep .v-chip.v-chip--small.v-chip--close[color="#F15A24"] .v-chip__close,
.annotation ::v-deep .v-chip.v-chip--small.v-chip--close[color="#F15A24"] .v-chip__close i,
.annotation ::v-deep .v-chip.v-chip--small.v-chip--close .v-chip__close,
.annotation ::v-deep .v-chip.v-chip--small.v-chip--close .v-chip__close i {
  color: white !important;
  opacity: 1 !important;
}

.annotation ::v-deep .v-chip.v-chip--small.v-chip--close .v-chip__close:hover,
.annotation ::v-deep .v-chip.v-chip--small.v-chip--close .v-chip__close:hover i {
  color: white !important;
  opacity: 0.8 !important;
}

/* Garantir que os ícones dentro dos chips sejam brancos (ícone de arquivo) */
.annotation ::v-deep .v-chip[color="#F15A24"][text-color="white"] .v-icon,
.annotation ::v-deep .v-chip[color="#F15A24"][text-color="white"] i,
.annotation ::v-deep .v-chip.v-chip--small[color="#F15A24"] .v-icon,
.annotation ::v-deep .v-chip.v-chip--small[color="#F15A24"] i {
  color: white !important;
}

/* Específico para chips de anexos nos comentários */
.annotation ::v-deep .v-chip[color="#F15A24"][text-color="white"] .v-chip__content .v-icon,
.annotation ::v-deep .v-chip[color="#F15A24"][text-color="white"] .v-chip__content i {
  color: white !important;
}

/* Estilos estilo Facebook para área de comentário */
.comment-input-container {
  background-color: #f0f2f5;
  border-radius: 20px;
  padding: 8px 12px;
  transition: background-color 0.2s;
}

.comment-input-container.has-attachments {
  border-radius: 8px 8px 0 0;
}

.comment-input-container:hover {
  background-color: #e4e6eb;
}

.comment-text-field ::v-deep .v-input__control {
  min-height: auto !important;
}

.comment-text-field ::v-deep .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  padding: 0 !important;
  margin: 0 !important;
}

.comment-text-field ::v-deep input {
  font-size: 15px !important;
  padding: 0 !important;
}

.comment-text-field ::v-deep .v-input__append-outer {
  margin-top: 0 !important;
  margin-left: 0 !important;
  align-self: center !important;
}

.comment-text-field ::v-deep .v-input__append-outer .v-btn {
  margin: 0 !important;
  min-width: auto !important;
  height: auto !important;
}

.attachment-btn,
.send-btn {
  opacity: 0.7;
  transition: opacity 0.2s;
  margin: 0 !important;
}

.attachment-btn:hover,
.send-btn:hover {
  opacity: 1;
}

/* Preview de anexos estilo Facebook */
.attachments-preview {
  background-color: #f0f2f5;
  border-radius: 0 0 8px 8px;
  padding: 8px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.attachment-item {
  position: relative;
}

.image-preview {
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.image-preview .v-img {
  border-radius: 8px;
}

.remove-attachment-btn {
  background-color: rgba(0, 0, 0, 0.5) !important;
  margin: 4px !important;
}

.remove-attachment-btn:hover {
  background-color: rgba(0, 0, 0, 0.7) !important;
}

.file-preview {
  background-color: white;
  border-radius: 8px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  min-width: 200px;
}

.file-info {
  flex: 1;
  min-width: 0;
}

.file-name {
  font-size: 13px;
  color: #050505;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.remove-file-btn {
  opacity: 0.6;
  transition: opacity 0.2s;
}

.remove-file-btn:hover {
  opacity: 1;
}
</style>

<script>
import { VueEditor } from "vue2-editor";
export default {
  name: "Annotation",
  components: { VueEditor },
  props: ["annotation"],
  data() {
    return {
      comment: "",
      commentFiles: [],
      file: null,
      showComments: false,
      loadingComment: false,
      importPost: { id_lei: {}, id_reg: {} },
      loadingNewAnnotation: false,
      showNewAnnotation: false,
      confirmDelete: false,
      loadingDelete: false,
      statusAnnotation: [
        { text: "Público", value: "published" },
        { text: "Grupo", value: "group" },
        { text: "Privado", value: "private" },
        { text: "Apenas Amigos", value: "friend" },
        { text: "Arquivado", value: "archived" },
      ],
      customToolbar: [
        [{ font: [] }, { size: [] }],
        ["bold", "italic", "underline", "strike"],
        [{ color: [] }, { background: [] }],
        // [{ script: "super" }, { script: "sub" }],
        [
          { header: "1" },
          { header: "2" },
          "blockquote",
          "code-block",
        ],

        [
          { list: "ordered" },
          { list: "bullet" },
          { indent: "-1" },
          { indent: "+1" },
        ],
        ["direction", { align: [] }],
        ["link", "image", "video"],
        ["clean"],
      ],
    }
  },
  computed: {
    groups() {
      return this.$store.state.user.grupos
    },
    user() {
      return this.$store.state.user;
    },
    vadeMecuns() {
      return this.$store.state.vadeMecuns
    },

  },
  methods: {
    triggerFileInput() {
      if (this.$refs.fileInput && this.$refs.fileInput.$el) {
        const input = this.$refs.fileInput.$el.querySelector('input');
        if (input) input.click();
      }
    },
    async reloadComments() {
      try {
        let rdm = Math.random()
        let fields = "id,message,user_created.id,user_created.first_name,user_created.avatar,files.directus_files_id.*"
        let { data } = await this.$http(`/items/comentarios?sort=-date_created&fields=${fields}&filter[status][_eq]=published&filter[annotation][_eq]=${this.annotation.id}&rdm=${rdm}`);
        // Usar $set para garantir reatividade quando atualizando prop
        this.$set(this.annotation, 'comentarios', data.data || [])
        // Forçar atualização da view para garantir renderização
        await this.$nextTick()
        this.$forceUpdate()
      } catch (e) {
        window.console.error('Erro ao recarregar comentários:', e)
      }
    },
    handleEnterKey(event) {
      // Se Shift+Enter, permitir quebra de linha; se apenas Enter, enviar comentário
      if (event.shiftKey) {
        return; // Permite quebra de linha
      }
      event.preventDefault();
      this.postComment();
    },
    async postComment() {
      if (this.loadingComment) return; // Evitar múltiplos envios
      if (this.comment.length > 1000) return;
      if (!this.comment.trim() && this.commentFiles.length === 0) return; // Evitar comentários vazios
      
      this.loadingComment = true;
      try {
        const files = this.commentFiles.map(e => ({ directus_files_id: { id: e.id } }))

        const { data } = await this.$http.post("/items/comentarios", {
          annotation: this.annotation.id,
          status: "published",
          message: this.comment,
          files: { create: files }
        });

        if (data.data.id) {
          this.comment = ""
          this.commentFiles = []
          // Garantir que os comentários sejam exibidos após postar
          this.showComments = true
          // Recarregar comentários e aguardar atualização
          await this.reloadComments()
        }
      }
      catch (e) {
        window.console.error('Erro ao postar comentário:', e)
      }
      finally {
        this.loadingComment = false;
      }
    },
    async deleteComment(id) {
      try {
        await this.$http.patch("/items/comentarios/" + id, { status: "draft" })
        this.reloadComments()
      } catch (error) {
        window.console.error('Erro ao excluir comentário:', error)
      }
    },
    async deleteAnnotation() {
      this.loadingDelete = true;
      try {
        await this.$http.patch(`/items/anotacoes/${this.annotation.id}`, {
          status: 'archived',
        });
        this.confirmDelete = false;
        this.loadingDelete = false;
        // Emitir evento para o componente pai recarregar o feed
        this.$emit('annotation-deleted', this.annotation.id);
      } catch (error) {
        window.console.error('Erro ao excluir anotação:', error);
        this.loadingDelete = false;
      }
    },
    async likeAnnotation() {
      try {
        const likes = { create: [{ directus_users_id: this.user.id, anotacoes_id: this.annotation.id }] }
        await this.$http.patch("/items/anotacoes/" + this.annotation.id, { likes })
        
        // Buscar dados atualizados com os objetos completos
        const { data } = await this.$http.get("/items/anotacoes/" + this.annotation.id + "?fields=likes.id,likes.first_name")
        this.annotation.likes = data.data.likes
      } catch (error) {
        window.console.error('Erro ao curtir:', error.response || error)
      }
    },
    async unlikeAnnotation() {
      try {
        let idCurtida = null
        this.annotation.likes.find((l) => {
          if (l.id === this.user.id) {
            idCurtida = l.id
          }
        })
        const likes = { delete: [idCurtida] }
        await this.$http.patch("/items/anotacoes/" + this.annotation.id, { likes })
        
        // Buscar dados atualizados com os objetos completos
        const { data } = await this.$http.get("/items/anotacoes/" + this.annotation.id + "?fields=likes.id,likes.first_name")
        this.annotation.likes = data.data.likes
      } catch (error) {
        window.console.error('Erro ao descurtir:', error.response || error)
      }
    },
    truncateFilename(filename, maxLength = 30) {
      if (!filename) return 'Anexo';
      if (filename.length <= maxLength) return filename;
      const extension = filename.split('.').pop();
      const nameWithoutExt = filename.substring(0, filename.lastIndexOf('.'));
      const truncatedName = nameWithoutExt.substring(0, maxLength - extension.length - 4);
      return `${truncatedName}...${extension}`;
    },
    isImageFile(file) {
      if (!file || !file.filename_download) return false;
      const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg'];
      const extension = file.filename_download.split('.').pop().toLowerCase();
      return imageExtensions.includes(extension);
    },
    downloadFile(fileId) {
      if (!fileId) return;
      const downloadUrl = `https://api.mylegis.com.br/assets/${fileId}?download`;
      window.open(downloadUrl, '_blank');
    },
    sanitizeTitle(title) {
      var slug = "";
      // Change to lower case
      var titleLower = title.toLowerCase();
      // Letter "e"
      slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, "e");
      // Letter "a"
      slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, "a");
      // Letter "o"
      slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, "o");
      // Letter "u"
      slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, "u");
      // Letter "d"
      slug = slug.replace(/đ/gi, "d");
      // Trim the last whitespace
      slug = slug.replace(/\s*$/g, "");
      // Change whitespace to "-"
      slug = slug.replace(/\s+/g, "-");

      return slug;
    },
    slugName(user) {
      return user.id + "/" + this.sanitizeTitle(user.first_name)
    },
    handleImageAdded(file, Editor, cursorLocation) {
      const formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let url = `https://api.mylegis.com.br/assets/${response.data.data.id}`;
          Editor.insertEmbed(cursorLocation, "image", url);
        })
        .catch((err) => {
          window.console.error('Erro ao fazer upload da imagem:', err);
        });
    },
    handleFileAdded(file) {
      if (!file) return;
      const formData = new FormData();
      formData.append("file", file);
      this.$http
        .post("/files", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          let uploadedFile = response.data.data;
          // Garantir que o arquivo tenha filename_download
          if (uploadedFile && uploadedFile.id) {
            this.commentFiles.push(uploadedFile);
          }
        })
        .catch((err) => {
          window.console.error('Erro ao fazer upload do arquivo:', err);
        });
    },
    // saveNewAnnotation() {
    //   this.loadingNewAnnotation = true;
    //   let dt = {
    //     id_lei: this.importPost.id_lei,
    //     id_reg: this.importPost.id_reg,
    //     status: this.importPost.status,
    //     id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
    //     texto: this.importPost.texto,
    //     id_vademecum: this.importPost.id_vademecum
    //   };
    //   this.$http
    //     .post("items/anotacoes", dt)
    //     .then((response) => {
    //       if (response.data.data.id != undefined) {
    //         this.loadingNewAnnotation = false;
    //         this.showNewAnnotation = false;
    //         // this.importPost = { status: "private" };
    //         this.importPost = { id_lei: {}, id_reg: {} },
    //           this.conteudoSelected = {};


    //         let conteudo = this.conteudos.find(
    //           (el) => el.id_reg === dt.id_reg
    //         );
    //         if (conteudo.anotacoes)
    //           conteudo.anotacoes.push(response.data.data);
    //         else conteudo.anotacoes = [response.data.data];
    //       }
    //     })
    //     .catch(() => {
    //       this.loadingNewAnnotation = false;
    //     });
    // },

    saveNewAnnotation() {
      this.loadingNewAnnotation = true;

      this.verificarEAdicionarLeiNoVadeMecum()
        .then(() => {
          let dt = {
            id_lei: this.importPost.id_lei,
            id_reg: this.importPost.id_reg,
            status: this.importPost.status,
            id_grupo: this.importPost.status == `group` ? this.importPost.id_grupo : null,
            texto: this.importPost.texto,
            id_vademecum: this.importPost.id_vademecum
          };

          return this.$http.post("items/anotacoes", dt);
        })
        .then((response) => {
          if (response.data.data.id != undefined) {
            this.loadingNewAnnotation = false;
            this.showNewAnnotation = false;
            this.importPost = { id_lei: {}, id_reg: {} };
            this.conteudoSelected = {};

            let conteudo = this.conteudos.find((el) => el.id_reg === this.importPost.id_reg);
            if (conteudo.anotacoes)
              conteudo.anotacoes.push(response.data.data);
            else conteudo.anotacoes = [response.data.data];
          }
        })
        .catch((error) => {
          window.console.error('Erro:', error);
          this.loadingNewAnnotation = false;
        });
    },

    verificarEAdicionarLeiNoVadeMecum() {
      return new Promise((resolve) => {
        // Substituir o optional chaining por verificações tradicionais
        let leiId;
        if (this.importPost.id_lei && typeof this.importPost.id_lei === 'object') {
          leiId = this.importPost.id_lei.id_lei;
        } else {
          leiId = this.importPost.id_lei;
        }

        const vadeMecumId = this.importPost.id_vademecum;

        if (!leiId || !vadeMecumId) {
          resolve();
          return;
        }

        this.$http.get(`items/vademecums/${vadeMecumId}?fields=*,leis.leis_id_lei.id_lei`)
          .then(response => {
            const vadeMecum = response.data.data;

            // Verificar se a lei já existe no vade-mécum
            let leiExiste = false;
            if (vadeMecum.leis && Array.isArray(vadeMecum.leis)) {
              leiExiste = vadeMecum.leis.some(item => {
                return item.leis_id_lei && item.leis_id_lei.id_lei === leiId;
              });
            }

            if (!leiExiste) {
              return this.$http.patch(`items/vademecums/${vadeMecumId}`, {
                leis: {
                  create: [{
                    leis_id_lei: { id_lei: leiId },
                    vademecums_id: vadeMecumId,
                  }]
                }
              });
            } else {
              return Promise.resolve();
            }
          })
          .then(() => {
            resolve();
          })
          .catch((error) => {
            window.console.error('Erro ao verificar vade-mécum:', error);
            resolve(); // Continua mesmo com erro
          });
      });
    }
  }
}
</script>